export default "__VITE_ASSET__DIW$8LGK__"